import AvailableChecklistFilter from './AvailableChecklistFilter';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { checklistTableStyles } from '../../../../utils/dataTableStyles';

interface Checklist {
    id: number;
    name: string;
    description: string;
    total_questions: number;
    max_possible_score: number;
}

interface ChecklistFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    search: string;
}

interface Props {
    checklists: Checklist[];
    totalRows: number;
    loading?: boolean;
    start?: (id: number) => void;
    filter: ChecklistFilters;
    setFilter: (filter: ChecklistFilters) => void;
    onSearch: () => void;
}

const AvailableChecklistDataTable = ({
    checklists,
    totalRows,
    loading = false,
    start,
    filter,
    setFilter,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            minWidth: '320px',
            grow: 2,
            cell: (row: Checklist) => (
                <div
                    className="py-1 pe-3"
                    style={{
                        minWidth: 0,
                        maxWidth: '100%',
                        wordBreak: 'break-word',
                        overflowWrap: 'anywhere',
                        whiteSpace: 'normal',
                        lineHeight: 1.55
                    }}
                >
                    <strong
                        className="d-block mb-2"
                        style={{ fontSize: '0.95rem', lineHeight: 1.45 }}
                    >
                        {row.name}
                    </strong>
                    <p
                        className="mb-0 text-muted"
                        style={{
                            fontSize: '0.875rem',
                            lineHeight: 1.65,
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            whiteSpace: 'normal'
                        }}
                    >
                        {row.description}
                    </p>
                </div>
            )
        },
        {
            name: 'Preguntas',
            selector: (row: any) => row.total_questions,
            sortable: true,
            sortField: 'total_questions',
            grow: 0,
            minWidth: '140px',
            cell: (row: Checklist) => (
                <div className="d-flex align-items-center py-1">
                    <span className="badge bg-info px-3 py-2 text-nowrap">
                        <i className="fas fa-question-circle me-1" />
                        {row.total_questions} preguntas
                    </span>
                </div>
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            grow: 0,
            minWidth: '110px',
            cell: (row: Checklist) => (
                <div className="d-flex align-items-center justify-content-center py-1">
                    {start && (
                        <ButtonTableAction
                            callbackFunction={() => start(row.id)}
                            title="Comenzar"
                            classIcon="fa-play"
                            colorIcon="text-success"
                            sizeIcon="16"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3 mb-4">
                <div className="col">
                    <AvailableChecklistFilter filter={filter} setFilter={setFilter} onSearch={onSearch} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={checklists}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
                styleTable={checklistTableStyles}
            />
        </>
    );
};

export default AvailableChecklistDataTable;
